<template>
	<el-drawer :modal="false" title="Settlement Details" :visible.sync="is_visible" class="drawer-settlement-details" size="60%" @closed="hide()">
		<ModalAddDisbursement ref="modal_add_disbursement" @closeModal="closeModal()" />
		<div slot="title" class="d-flex align-items-center justify-content-between">
			<span>Settlement Details</span>
			<el-button type="primary" plain size="mini" class="mr-4" @click.native="$refs.modal_add_disbursement.show()" v-if="!is_loading">
				<p>+ Add Disbursement</p>
			</el-button>
		</div>
		<b-container>
			<b-row>
				<b-col cols="12"  v-loading="is_loading">
					<div class="table-listings">
						<el-table ref="ccrisTable" style="width: 100%" size="small" show-summary
							:data="tableData" :header-cell-class-name="'text-13px'" :summary-method="getSummaries">
							<!-- CHECKBOX -->
							<!-- <el-table-column v-if=" _gHlp.checkAccess(allowAssignRoles)" type="selection" class-name="pb-3" width="55" fixed></el-table-column> -->
							<el-table-column type="index" width="50" class-name="text-center font-weight-bold"></el-table-column>

							<el-table-column label="Loan Facility" min-width="150" prop="loan_facility" sortable has_summary>
								<template slot="header">
									Loan<br>Facility
								</template>
								<template slot-scope="scope">
									<b-form-input v-model="scope.row.loan_facility" size="sm" :disabled="scope.row.status == 'Done'"></b-form-input>
								</template>
							</el-table-column>

							<el-table-column label="Settlement Status" min-width="140" prop="status" sortable>
								<template slot="header">
									Settlement<br> Status
								</template>
								<template slot-scope="scope">
									<p>{{ scope.row.status }}</p>
								</template>
							</el-table-column>

							<el-table-column label="Bank" min-width="160" prop="bank_id" sortable>
								<template slot-scope="scope">
									<b-form-select v-model="scope.row.bank_id" size="sm"
										:disabled="scope.row.status == 'Done'" >
										<b-form-select-option v-for="item in allBanks" :key="item.bank_id" :value="item.bank_id">{{
											item.name }}</b-form-select-option>
									</b-form-select>
								</template>
							</el-table-column>

							<el-table-column label="Account No" min-width="160" prop="account_no" sortable>
								<template slot-scope="scope">
									<b-form-input v-model="scope.row.account_no" :disabled="scope.row.status == 'Done'" size="sm"></b-form-input>
								</template>
							</el-table-column>

							<el-table-column label="Settlement Amount (RM)" min-width="180" prop="settlement_amt" sortable>
								<template slot="header">
									Settlement<br>Amount (RM)
								</template>
								<template slot-scope="scope">
									<CurrencyInput className="text-right" v-model="scope.row.settlement_amt" size="sm" :disabled="scope.row.status == 'Done'"
										:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }"/>
								</template>
							</el-table-column>

							<el-table-column label="Current Outstanding (RM)" min-width="190" prop="current_outstanding" sortable>
								<template slot="header">
									Current<br>Outstanding (RM)
								</template>
								<template slot-scope="scope">
									<CurrencyInput className="text-right" v-model="scope.row.current_outstanding" size="sm" :disabled="scope.row.status == 'Done'"
										:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }"/>
								</template>
							</el-table-column>

							<el-table-column label="Merchant Solution (RM)" min-width="170" prop="merchant_solution" sortable>
								<template slot="header">
									Merchant<br>Solution (RM)
								</template>
								<template slot-scope="scope">
									<CurrencyInput className="text-right" v-model="scope.row.merchant_solution" size="sm" :disabled="scope.row.status == 'Done'"
										:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }"/>
								</template>
							</el-table-column>

							<el-table-column label="Payment Type" min-width="160" prop="payment_type" sortable>
								<template slot="header">
									Payment<br>Type
								</template>
								<template slot-scope="scope">
									<b-form-select v-model="scope.row.payment_type" size="sm" :disabled="scope.row.status == 'Done'">
											<b-form-select-option :value="''">--No Selected--</b-form-select-option>
											<b-form-select-option v-for="(item,index) in _gConst.paymentTypes" :key="index" :value="item">
												{{ item }}
											</b-form-select-option>
									</b-form-select>
								</template>
							</el-table-column>
							
							<el-table-column label="Paid Date" min-width="180" prop="merchant_solution" sortable>
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.paid_date" size="small" value-format="yyyy-MM-dd" type="date"  placeholder="Pick a day"  :disabled="scope.row.status == 'Done'"></el-date-picker>
								</template>
							</el-table-column>

							<el-table-column label="Remarks" min-width="140" prop="remarks" sortable>
								<template slot-scope="scope">
									<b-form-input v-model="scope.row.remarks" size="sm" :disabled="scope.row.status == 'Done'"></b-form-input>
								</template>
							</el-table-column>

							<!-- <el-table-column label="" min-width="40">
								<template slot-scope="scope">
									<el-dropdown trigger="click" style="cursor: pointer">
												<p class="el-dropdown-link mb-0 top-line">
													<b-icon icon="three-dots-vertical"></b-icon>
												</p>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                          <path fill="#13663E"
                            d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
                        </svg>
                        View Change Log
                      </el-dropdown-item>
													<el-dropdown-item @click.native="removeItem(scope.row.id, scope.$index)">
														<span class="text-danger">
															<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
																<path fill="#DF3030"
																	d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
															</svg>
															Delete
														</span>
													</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
								</template>
							</el-table-column> -->
						</el-table>
						<!-- <b-tr>
									<b-td colspan="13">
										<p class="text-primary cursor-pointer" @click="addNew">
											<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 448 512">
												<path fill="currentColor"
													d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
											</svg>
											Add
										</p>
									</b-td>
								</b-tr> -->
					</div>
					<div class="text-right p-2" v-if="!is_readonly">
						<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate" icon="el-icon-circle-check">Save & Calculate</el-button>
					</div>
				</b-col>
			</b-row>
		</b-container>

	</el-drawer>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Table, TableColumn, Drawer, Button, Dropdown, DropdownItem, DropdownMenu, DatePicker } from 'element-ui'
import ModalAddDisbursement from '@/views/CreditLoanCase/Modals/ModalAddDisbursement';
import clientPaginationMixin from '@/assets/js/clientPaginationMixin';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import CurrencyInput from '@/components/CurrencyInput'

export default {
	mixins: [clientPaginationMixin],
	components: {
		ModalAddDisbursement,
		CurrencyInput,
		[DatePicker.name]: DatePicker,
		[Drawer.name]: Drawer,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Table.name]: Table,
    [TableColumn.name]: TableColumn,
	},
	data() {
		return {
			is_visible: false,
			is_readonly: false,
			is_loading: false,
			current_customer_id: null,
			current_case_id: null,
			oldTableData: [],
			tableData: [],
			tableSummary: {},
			tableColumnSkipSummary: [0, 1, 2, 3, 4, 8, 9, 10],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			TableColumn: [{
				type: 'selection'
			}],
			deletedItemIds:[],
		}
	},
	computed: {
		...mapState(useCommonStore, ['allBanks'])
	},
	created() {
	},
	methods: {
		...mapActions(useLoanCaseStore, ['getSettlementsList', 'createOrUpdateSettlement', 'deleteSettlement']),
		show(customer_id, case_id, disbursement_status) {
			if(!_gHlp.isEmpty(customer_id) && !_gHlp.isEmpty(case_id)){
				this.current_customer_id = customer_id;
				this.current_case_id = case_id;
				this.is_visible = true;
				this.is_readonly = disbursement_status == 'Full Disbursement';
				this.getList(customer_id, case_id);
			}
		},
		hide(){
			this.tableData = []
			this.is_visible = false;
			this.is_readonly = false;
			this.current_customer_id = null;
			this.current_case_id = null;
		},
		getList(customer_id, case_id) {
			this.is_loading = true;
			const params = {
				search:{
					customer_id: customer_id,
					case_id: case_id
				}
			}
			this.getSettlementsList(params).then((resp) => {
				this.tableData = resp.data;
				this.oldTableData = cloneDeep(this.tableData)
				this.is_loading = false;
			}).catch(err => {
				this.oldTableData = []
				this.is_loading = false;
			});

		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			const cbData = [];

			columns.forEach((column, index) => {
				if (index === 4) {
					sums[index] = 'Total';
					return;
				}
				if (this.tableColumnSkipSummary.includes(index)) {
					return;
				}

				const values = data.map(item => {
					return Number(item[column.property])
				});
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
					cbData[column.property] = total
				} else {
					sums[index] = '';
				}
			});

			//callback
			this.tableSummary = cbData;
			return sums;
		},
		addNew() {
			this.tableData.push({
				customer_id: this.current_customer_id,
				case_id: this.current_case_id,
				loan_facility: '',
				status: 'Pending',
				advisor: '',
				bank_id: '',
				bank: '',
				account_no: '',
				settlement_amt: 0,
				current_outstanding: 0,
				merchant_solution: 0,
				payment_type: '',
				paid_date: '',
				remarks: '',
			});
		},
		removeItem(id, index) {
			// Check if the index is within the array bounds
			if (index >= 0 && index < this.tableData.length) {
				// Use splice to remove the item at the specified index
				this.tableData.splice(index, 1);
				if(!_gHlp.isEmpty(id)) {
					this.deletedItemIds.push(id);
				}
			}
		},
		getParams(item) {
			if(_gHlp.isEmpty(item)) return {}
			const bank = this.allBanks.find(bnk => bnk.bank_id == item.bank_id)
			return {
				id: item.id,
				customer_id: item.customer_id,
				case_id: item.case_id,
				loan_facility: item.loan_facility,
				status: item.status,
				advisor: item.advisor,
				bank_id: item.bank_id,
				bank: _gHlp.getValue(bank,'name',item.bank),
				account_no: item.account_no,
				settlement_amt: parseFloat(item.settlement_amt),
				current_outstanding: parseFloat(item.current_outstanding),
				merchant_solution: parseFloat(item.merchant_solution),
				payment_type: item.payment_type,
				paid_date: item.paid_date,
				remarks: item.remarks
			}
		},
		submitAndCalculate(){
			let updateItems = [];
			//DELETD ITEMS
			if(!_gHlp.isEmpty(this.deletedItemIds)){
				for(let i = 0; i < this.deletedItemIds.length; i++){
					let itmId = this.deletedItemIds[i];
					updateItems.push(this.deleteSettlement(itmId))
				}
			}

			//UPDATE ITEMS
			for (let idx = 0; idx < this.tableData.length; idx++) {
				const newData = this.getParams(this.tableData[idx])	
				const oldData = this.getParams(this.oldTableData.find(itm => itm.id === newData.id));
				if(_gHlp.isEmpty(oldData) || !isEqual(newData, oldData)) {
					updateItems.push(this.createOrUpdateSettlement(newData));
				}
			}
			
			if(!_gHlp.isEmpty(updateItems)){
				this.is_loading = true;
				Promise.all(updateItems)
				.then(res  => {
					this.oldTableData = cloneDeep(this.tableData)
					this.is_loading = false;
				})
				.catch(e => {
					this.is_loading = false;
				})
			}
		}
	}
}
</script>